<template>
<div class="myIndex">
    <div class="userInfo">
        <!-- 个人信息 -->
        <div class="user clearfix">
            <div class="f-l thumb">
                <img :src="imageUrl+info.thumb" alt />
            </div>
            <div class="f-l info">
                <div class="info_t">
                    <span class="user_name">{{ info.nickname }}</span>
                    <span class="user_tle">{{ info.username }}</span>
                </div>
            </div>
        </div>
    </div>
    <!--  -->
    <div class="con">
        <!-- 平台服务 -->
        <div class="list">
            <div class="title">平台服务</div>
            <ul class="list_con">
                <li class="item" @click="goPage('user-nickname')">
                    <img :src="this.publicPath+ 'statics/images/my/icon_adress.png'" alt="" class="icon">
                    <div class="txt">修改昵称</div>
                </li>
                <li class="item" @click="goPage('user-phone')">
                    <img :src="this.publicPath+ 'statics/images/my/icon_yuekan.png'" alt="" class="icon">
                    <div class="txt">修改手机号</div>
                </li>
                <li class="item" @click="goPage('user-password')">
                    <img :src="this.publicPath+ 'statics/images/my/icon_ziti.png'" alt="" class="icon">
                    <div class="txt">修改密码</div>
                </li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            ordertab: 'a',
            publicPath: process.env.BASE_URL,
            info: {}, // 用户信息
            nums: {}, // 分享等信息
            userrole: {}, // 用户角色  "is_partner": 0, //是否是城市合伙人0否1是  "is_agent": 1,//是否是代理商户0否1是 "is_seller": 0,//是否是经销商0否1是  "is_tradesman": 0,//是否匠人0否1是
            useraccount: {}, //账户信息
            isClient: false,//是否在iOSAndroid客户端内显示
            token:null,
        };
    },
    created: function () {
        
    },
    mounted: function() {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            this.setClientInfo()
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.setClientInfo()
                responseCallback('refresh success')
            })
            //注册方法，右上角设置按钮点击事件
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                responseCallback('success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    methods: {
        setClientInfo() {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '设置',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {
                
            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
        },
        // 获取列表
        getData() {
            console.log('123')
            if (this.token == null) {
                return
            }
            var params = {
                token: this.token
            }
            this.$api.my.info(params).then(res => {
                console.log('res')
                console.log(res)
                if (res.code == 200) {
					this.info = res.result.thumb
                } 
            })
        },
        // 页面跳转
        goPage(name) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {
                    }
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        name = name.replace("-","/")
                        var params = {'data':{'url':this.$publicData.clientUrl+'/'+name}}
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
					localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath
                        // }
                    })
                    return
                }
                this.$router.push({
                    name: name
                })
            }
        },
        // 退出
        logout() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                
            } else {
                this.$store.commit(LOGOUT);
                this.$router.push("/");
            }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
